// notes.ts — Step 5. Project-notes (quick-capture) methods.
// See workers/core-os/src/routes/notes.ts (project_notes, migration 0060).

import { request } from './request'

export type NoteCategory =
  | 'actionable'
  | 'observation'
  | 'question'
  | 'decision'
  | 'sub_relevant'

export type NotePriority = 'high' | 'medium' | 'low'

export interface NoteRow {
  id: string
  project_id: string
  body: string
  author_user_id: string | null
  category: NoteCategory | null
  priority: NotePriority | null
  action_summary: string | null
  classified_at: string | null
  archived_at: string | null
  created_at: string
  updated_at: string | null
}

export interface NoteListResponse {
  ok: true
  notes: NoteRow[]
  count: number
}

export interface NotesClassifyResponse {
  ok: true
  classified: number
  remaining: number
  by_category: Record<NoteCategory, number>
  request_id: string
}

export const notesApi = {
  list: (projectId: string) =>
    request<NoteListResponse>(
      `/api/projects/${encodeURIComponent(projectId)}/notes`,
    ),
  create: (projectId: string, body: { body: string; category?: NoteCategory }) =>
    request<{ ok: true; id: string; request_id: string }>(
      `/api/projects/${encodeURIComponent(projectId)}/notes`,
      { method: 'POST', body: JSON.stringify(body) },
    ),
  // AI-assess (category + priority + action) any unclassified notes.
  classify: (projectId: string) =>
    request<NotesClassifyResponse>(
      `/api/projects/${encodeURIComponent(projectId)}/notes/classify`,
      { method: 'POST', body: '{}' },
    ),
  update: (
    projectId: string,
    noteId: string,
    body: { body?: string; category?: NoteCategory | null; archived?: boolean },
  ) =>
    request<{ ok: true; id: string; updated: string[] }>(
      `/api/projects/${encodeURIComponent(projectId)}/notes/${encodeURIComponent(
        noteId,
      )}`,
      { method: 'PATCH', body: JSON.stringify(body) },
    ),
}
